import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import type { PropType } from 'vue'
import type { ClueManage } from '@/typings/api/marketingManage'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'

const __default__ = { name: 'TrackingTabs' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object as PropType<ClueManage['contact'][]>
  }
},
  setup(__props) {


const columns = ref([
  {
    title: '来源系统',
    dataIndex: 'acceptor',
    dicData: dataConfig.acceptClueSystem
  },
  {
    title: '操作人',
    dataIndex: 'operatorName'
  },
  {
    title: '操作时间',
    dataIndex: 'operateTime'
  },
  {
    title: '操作类型',
    dataIndex: 'operateType'
  },
  {
    title: '操作内容',
    dataIndex: 'operateDesc'
  }
])

return (_ctx: any,_cache: any) => {
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, {
      columns: columns.value,
      dataSource: __props.data,
      tableId: "Zbu_clueTracking_view_tack",
      needPage: false,
      ref: "table"
    }, null, 8, ["columns", "dataSource"]),
    _createVNode(_component_cos_footer_button, { hideOk: true })
  ], 64))
}
}

})